import dataTemplate from "../../service/data-template.service.js";
// import html2canvas from "html2canvas";
export default {
    name: "data-template",
    data() {
        return {
            jgLonghu: [],
            bxLongHu: [],
            bxZj: [],
            imgUrl: "",
            beixiang: {},
            date: {
                y: "",
                m: ""
            },
            qrCode: ""
        }
    },
    created() {
        this.createImg();
    },
    methods: {
        goIndex() {
            this.$router.push("/index");
        },
        createImg() {
            dataTemplate.getJigou().then(res => {
                let jigouQ5 = res.data.jigouQ5;
                let jigouH5 = res.data.jigouH5;
                let len = Math.max(jigouQ5.length, jigouH5.length);
                let day = res.data.day;
                this.date.y = day.slice(0, 5);
                this.date.m = day.slice(5);
                for (let i = 0; i < len; i++) {
                    this.jgLonghu.push({
                        jigouQ5: jigouQ5[i],
                        jigouH5: jigouH5[i]
                    });
                }
                let hgt = res.data.hgt;
                let sgt = res.data.sgt;
                let len2 = Math.max(hgt.length, sgt.length);
                for (let i = 0; i < len2; i++) {
                    this.bxLongHu.push({
                        hgt: hgt[i],
                        sgt: sgt[i]
                    });
                }
                let hgtLr = res.data.hgtLr;
                let sgtJe = res.data.sgtJe;
                let len3 = Math.max(hgtLr.length, sgtJe.length);
                for (let i = 0; i < len3; i++) {
                    this.bxZj.push({
                        hgtLr: hgtLr[i],
                        sgtJe: sgtJe[i]
                    });
                }
                this.beixiang = res.data.beixiang;

                // this.qrCode = res.data.qrCode;
                // setTimeout(() => {
                //     let containerEl = this.$refs.imgBox;
                //     let height = parseFloat(getComputedStyle(containerEl).height);
                //     html2canvas(containerEl, {
                //         scale: 4,
                //         removeContainer: true,
                //         useCORS: true,
                //         imageTimeout: 15000,
                //         windowHeight: height,
                //         windowWidth: parseFloat(getComputedStyle(containerEl).width),
                //         allowTaint: false,
                //         height: height,
                //         scrollX: 0,
                //         scrollY: 0,
                //         x: 0,
                //         y: 0
                //     }).then(canvas => {
                //         let imgUrl = canvas.toDataURL();
                //         this.imgUrl = imgUrl;
                //         containerEl.style.display = "none";
                //     });
                // }, 0);
            });
        }
    }
};